var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-form",
            {
              staticClass: "collaborators__form-dialog",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                }
              }
            },
            [
              _c("v-card-title", { staticClass: "collaborators__form-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.title))])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Nombres",
                          error: _vm.$v.teamName.$error,
                          "error-messages": _vm.teamNameErrorMessages,
                          maxlength: 40
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.teamName.$touch()
                          },
                          keypress: _vm.lettersAndNumbers,
                          keyup: _vm.validName
                        },
                        model: {
                          value: _vm.teamName,
                          callback: function($$v) {
                            _vm.teamName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "teamName"
                        }
                      }),
                      _c("v-checkbox", {
                        staticClass:
                          "collaborators__checkbox first__checkbox-item",
                        attrs: { label: "Puede hacer registros temporales" },
                        model: {
                          value: _vm.temp,
                          callback: function($$v) {
                            _vm.temp = $$v
                          },
                          expression: "temp"
                        }
                      }),
                      _c("v-checkbox", {
                        staticClass: "collaborators__checkbox",
                        attrs: { label: "Puede hacer registros multicomercio" },
                        model: {
                          value: _vm.multi,
                          callback: function($$v) {
                            _vm.multi = $$v
                          },
                          expression: "multi"
                        }
                      }),
                      _c("div", { staticClass: "slide__item-switch" }, [
                        _c("h3", [_vm._v("Estado")]),
                        _c(
                          "div",
                          { staticClass: "slide__switch" },
                          [
                            _c("v-switch", {
                              attrs: {
                                disabled:
                                  _vm.loading ||
                                  !_vm.teamIsActive ||
                                  !_vm.channelIsActive
                              },
                              model: {
                                value: _vm.switchState,
                                callback: function($$v) {
                                  _vm.switchState = $$v
                                },
                                expression: "switchState"
                              }
                            }),
                            _vm.switchState
                              ? _c("p", [_vm._v("Activo")])
                              : _c("p", [_vm._v("Inactivo")])
                          ],
                          1
                        )
                      ]),
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.conditionalShowMessageStatus,
                              expression: "conditionalShowMessageStatus"
                            }
                          ],
                          staticClass: "collaborators-message"
                        },
                        [
                          _vm._v(
                            '"Si desactiva el equipo, el supervisor y vendedores no podrán acceder al sistema”'
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "collaborators__buttons-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button text black uppercase",
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button blue w110",
                      attrs: {
                        type: "submit",
                        disabled:
                          _vm.sending ||
                          _vm.$v.$invalid ||
                          !_vm.resultValidNameService
                      }
                    },
                    [_vm._v(_vm._s(_vm.actionButton))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b2650bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b2650bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/new-team-modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5b2650bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/new-team-modal.vue
// module chunks = 4 6 8